import moment from "moment";
import React from 'react';

export const configSalesHeader = [
    {name: "salesName", label: "Nama Sales/\nCS", options: {sort: false}},
];

function getDaysInMonth(year, month) {
  const date = moment({
    year: year !== undefined ? year : moment().year(),
    month: month !== undefined ? month - 1 : moment().month(),
  });

  return date.daysInMonth();
}

export const getConfigDaily = (month, year) => {
    const currentTotalMonth = getDaysInMonth(year, month);
    const daysArray = Array.from({ length: currentTotalMonth }, (_, i) => ({
      name: String(i + 1),
      label: i + 1,
      options: { sort: false },
    }));
    return [
      {
        name: "employeeName",
        label: "Nama Sales / CS",
        options: { 
          sort: false,
          customRowRender:()=><div><p>asd</p></div>
        },
      },
      ...daysArray,
      {
        name: "total",
        label: "Total",
        options: { sort: false },
      },
      {
        name: "target",
        label: "Target",
        options: { sort: false },
      },
      {
        name: "achievement",
        label: "%achv",
        options: { sort: false },
      },
      {
        name: "projection",
        label: "Proyeksi",
        options: { sort: false },
      },
    ];
}

export const configDailySalesReportBySalesman = [
    {name: "date", label: "Tanggal", options: {sort: false}},
    {name: "dailyCash", label: "Cash\nHarian", options: {sort: false}},
    {name: "accumulateCash", label: "Cash\nAkumulasi", options: {sort: false}},
    {name: "spCash", label: "Cash\n%sp", options: {sort: false}},
    {name: "dailyKDS", label: "KDS\nHarian", options: {sort: false}},
    {name: "accumulateKDS", label: "KDS\nAkumulasi", options: {sort: false}},
    {name: "spKDS", label: "KDS\n%sp", options: {sort: false}},
    {name: "dailyCredit", label: "Kredit\nHarian", options: {sort: false}},
    {name: "spCredit", label: "Kredit\n%sp", options: {sort: false}},
    {name: "accumulateCredit", label: "Kredit\nAkumulasi", options: {sort: false}},
    {name: "dailyTotal", label: "Total\nHarian", options: {sort: false}},
    {name: "accumulateTotal", label: "Total\nAkumulasi", options: {sort: false}},
];

export const configMonthToDateBySales = [
    {name: "name", label: "Nama Sales/\nCS", options: {sort: false,}},
    {name: "lastMonth", label: "Last Month", options: {sort: false,}},
    {name: "thisMonth", label: "This Month", options: {sort: false,}},
    {name: "growth", label: "Growth", options: {sort: false,customBodyRender: (val) => (val!== null ? `${val}%` : null)}},
    {name: "forecasting", label: "Proyeksi", options: {sort: false,}},
];

const rupiahToNumber = (value) => {
  if (!value) return 0;
  return Number(value.replace(/[^\d]/g, ""));
};

export const service = {
  transformChartDataFromApi: (rawData) => {
    const result = {
      Y2: { year: "Y-2", MECHANIC: 0, SA: 0 },
      Y1: { year: "Y-1", MECHANIC: 0, SA: 0 },
      Y:  { year: "Y",   MECHANIC: 0, SA: 0 },
    };

    rawData.forEach((item) => {
      const role = item.employeeRole;

      // Y-2
      result.Y2[role] +=
        rupiahToNumber(item.y2q1) +
        rupiahToNumber(item.y2q2) +
        rupiahToNumber(item.y2q3) +
        rupiahToNumber(item.y2q4);

      // Y-1
      result.Y1[role] +=
        rupiahToNumber(item.y1q1) +
        rupiahToNumber(item.y1q2) +
        rupiahToNumber(item.y1q3) +
        rupiahToNumber(item.y1q4);

      // Y
      result.Y[role] +=
        rupiahToNumber(item.yq1) +
        rupiahToNumber(item.yq2) +
        rupiahToNumber(item.yq3) +
        rupiahToNumber(item.yq4);
    });

    const data = [result.Y2, result.Y1, result.Y];

    const dataKey = [
      {
        key: "MECHANIC",
        label: "Mechanic",
        color: "#E53935", 
      },
      {
        key: "SA",
        label: "Service Advisor",
        color: "#43A047", 
      },
    ];

    return { data, dataKey };
  },
};